<script>
  export let value = ""
  export let className = ""
  export let onInput = () => {}

  let displayValue = value.toString()

  function formatNumber(val) {
    // Elimina todo excepto dígitos
    const cleaned = val.replace(/\D/g, "")

    // Formatea con separadores de miles
    return cleaned.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }

  function handleInput(e) {
    const raw = e.target.value
    const formatted = formatNumber(raw)
    displayValue = formatted
    onInput(formatted.replace(/,/g, ""), formatted)
  }

  $: displayValue = formatNumber(value.toString())
</script>

<input
  type="text"
  bind:value={displayValue}
  on:input={handleInput}
  inputmode="numeric"
  autocomplete="off"
  spellcheck="false"
  class={className}
/>
